export const SCREEN_WEATHER_LIST = [
  {
    name: "common.weather.clearDay",
    icon: "qingtian",
    selected: false,
  },
  {
    name: "common.weather.cloudy",
    icon: "nongyun",
    selected: true,
  },
  {
    name: "common.weather.overcastSky",
    icon: "yintian1",
    selected: false,
  },
  {
    name: "common.weather.rain",
    icon: "xiayu",
    selected: false,
  },
  {
    name: "common.weather.thundershower",
    icon: "leizhenyu",
    selected: false,
  },
  {
    name: "common.weather.typhoon",
    icon: "taifeng",
    selected: false,
  },
  {
    name: "common.weather.lowTemperature",
    icon: "diwen",
    selected: false,
  },
  {
    name: "common.weather.highTemperature",
    icon: "teshugaowen",
    selected: false,
  },
];

export const SCREEN_DRIVER_DATA_LIST = [
  {
    name: "吴师傅",
    income: 240.95,
    score: 8.4,
  },
  {
    name: "崔师傅",
    income: 400.14,
    score: 10.0,
  },
  {
    name: "肖师傅",
    income: 160.76,
    score: 7.6,
  },
  {
    name: "赖师傅",
    income: 273.51,
    score: 8.7,
  },
  {
    name: "郭师傅",
    income: 284.25,
    score: 8.8,
  },
  {
    name: "詹师傅",
    income: 223.96,
    score: 8.2,
  },
  {
    name: "彭师傅",
    income: 318.23,
    score: 9.1,
  },
  {
    name: "梁师傅",
    income: 120.34,
    score: 7.2,
  },
  {
    name: "刘师傅",
    income: 250.77,
    score: 8.5,
  },
  {
    name: "尹师傅",
    income: 360.01,
    score: 9.6,
  },
];

export const SCREEN_CARTYPE_NAME_LIST = [
  {
    name: "fuk",
    label: "screen.carType.fuk",
  },
  {
    name: "normal",
    label: "screen.carType.normal",
  },
  {
    name: "LUXURY",
    label: "screen.carType.LUXURY",
  },
];

export const SCREEN_ONLINE_NAME_LIST = [
  {
    name: "online",
    label: "screen.onlineProportion",
  },
  {
    name: "offline",
    label: "screen.offlineProportion",
  },
];

export const SCREEN_PAYMENT_NAME_LIST = [
  {
    name: "cashPay",
    label: "screen.payment.cashPay",
  },
  {
    name: "wechatPay",
    label: "screen.payment.wechatPay",
  },
  {
    name: "alipayPay",
    label: "screen.payment.alipayPay",
  },
];

// 订单类型
export const SCREEN_ORDER_TYPE_LIST = [
	{
		index: 0,
		name: null,
		label: "screen.orderType.unknownType",
	},
	{
		index: 1,
		name: "REAL_TIME_ORDER",
		label: "screen.orderType.realTimeOrder",
	},
	{
		index: 2,
		name: "SUBSCRIBE_ORDER",
		label: "screen.orderType.subscribeOrder",
	},
	{
		index: 3,
		name: "FIXED_ORDER",
		label: "screen.orderType.fixedOrder",
	},
  {
    index: 4,
    name: "SET_ORDER",
    label: "screen.orderType.setOrder",
  },
];

// 订单的所有状态
export const SCREEN_ORDER_STATUS_LIST = [
	{
		index: 0,
		name: null,
		label: "screen.orderStatus.unknownOrderStatus"
	},
	{
		index: 1,
		name: "SUBSCRIBE",
		label: "screen.orderStatus.orderPlacedSuccessfully"
	},
	{
		index: 2,
		name: "WAIT_ANSWER",
		label: "screen.orderStatus.searchingForDrivers"
	},
	{
		index: 3,
		name: "RECEIVED_ORDERS",
		label: "screen.orderStatus.driverAcceptedOrder"
	},
	{
		index: 4,
		name: "GO_TO_START",
		label: "screen.orderStatus.driverOnWayToStartingPoint"
	},
	{
		index: 5,
		name: "ARRIVE_START",
		label: "screen.orderStatus.haveReachedStartingPoint"
	},
	{
		index: 6,
		name: "CONFIRM_BOARDING",
		label: "screen.orderStatus.journeyUnderway"
	},
	{
		index: 7,
		name: "END_OF_STROKE",
		label: "screen.orderStatus.endOfJourney"
	},
	{
		index: 8,
		name: "CONFIRM_COSTS",
		label: "screen.orderStatus.waitingForPayment"
	},
	{
		index: 9,
		name: "PAYMENTED",
		label: "screen.orderStatus.paymentCompleted"
	},
	{
		index: 10,
		name: "CUSTOMER_CANCEL",
		label: "screen.orderStatus.orderRevocation"
	},
	{
		index: 11,
		name: "CUSTOMER_FAIL_CANCEL",
		label: "screen.orderStatus.orderCancelled"
	},
	{
		index: 12,
		name: "DRIVER_CANCEL",
		label: "screen.orderStatus.driverCancelledOrder"
	},
	{
		index: 13,
		name: "FAILED",
		label: "screen.orderStatus.orderClosedAbnormal"
	},
	{
		index: 14,
		name: "NO_Driver_Response",
		label: "screen.orderStatus.noDriverResponse"
	},
]
